import * as React from "react";
import Svg, { Rect } from "react-native-svg";
import { IconlyIconProps } from "./interface";
const Poland = ({
    size=640
}:IconlyIconProps) => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={(size / 640) * 400}
    viewBox="0 0 8 5"
    
  >
    <Rect
      x={0}
      y={0}
      width={8}
      height={5}
      stroke="#000"
      strokeWidth={0.1}
      fill="none"
    />

    <Rect width={8} height={5} fill="#dc143c" />
    <Rect width={8} height={2.5} fill="#fff" />
  </Svg>
);
export default Poland;
